import { authFetch } from 'src/auth/utils';
import { CreateClientConfig } from 'src/clients/locations/Device Locations API/client.gen';
import { envVariables } from 'src/common/utils/envVariables';

export const createClientConfig: CreateClientConfig = (config) => {
  return {
    ...config,
    baseUrl: envVariables.VITE_LOCATIONS_BASE_API,
    fetch: authFetch,
  };
};
